<template>
  <div id="app">
    <div class="app-router">
      <transition>
        <keep-alive v-if="this.$route.meta.kep">
          <router-view></router-view>
        </keep-alive>
        <router-view v-else></router-view>
      </transition>
    </div>
    <NavBar v-if="!this.$route.meta.showtabbarfalse"></NavBar>
  </div>
</template>
<script>
// import { articleList } from "@/server/server/hospitalNews/";
import NavBar from "components/tabBar";
import { jssdk ,getHosDeatil} from "server/home";
import {setStore} from "./config/global";
export default {
  data() {
    return {};
  },
  created(){
    let tokenQuery = this.$route.query.token
    if (tokenQuery) {
      setStore('token', tokenQuery)
    }
  },
  mounted() {
    if(window.location.href.includes('?token')){
				window.location.href = window.location.href.split('?token')[0]
			}
    this.getHosDetail()
    // this.getArticleList()
    let params = {
      url: window.location.origin,
    };
    jssdk(params).then((res) => {
      this.$store.commit("setjssdk", res);
    });

  },
  watch: {},
  methods: {
    hiddenPrevent() {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    // 获取医院简介页医院信息
    getHosDetail(){
      getHosDeatil().then((res)=>{
        if(res){
          this.$store.commit('setHosDetail',res)
        }
      })
    },
    // 获取首页医院动态
    // getArticleList() {
    //   console.log("获取公众号文章的永久素材");
    //   const params = {
    //     type: "news",
    //     offset: "0",
    //   };
    //   articleList(params)
    //     .then((res) => {
    //     let articleList = res.item.slice(0, 2);
    //       console.log("appthis.a2332322rticleList", articleList);
    //       this.$store.commit('setHosArticles',articleList)
    //       console.log("this.$store.state.hosArticles",this.$store.state.hosArticles);
    //     })
    //     .catch((err) => {
    //     });
    // },
  },
  components: {
    NavBar,
  },
};
</script>
<style lang="scss">
@import "./font/font.css";
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  font-family:'zkFont';
}

.van-dialog__confirm{
color: $weixin-font-color !important;
}
#app {
  height: 100vh;
  // position: fixed;
  // width:100%;
  // z-index: 1;
  // overflow-y: auto;
  // top: 0;
  // left: 0;
  // overflow: auto;
}
#nprogress .bar {
//  background: #DE9C62 !important; //自定义颜色
 background: $weixin-bgc-color !important; //自定义颜色
}
#nprogress .spinner-icon{
  // border-top-color: #DE9C62 !important;
  // border-left-color: #DE9C62 !important;
  border-top-color: $weixin-btn-color !important;
  border-left-color: $weixin-btn-color !important;
}
.app-router {
  height: 100%;
}
body ::v-deep .van-toast {
  // background-color: #DE9C62;
  background-color: $weixin-bgc-color;
  min-width: 5.66667rem;
  border-radius: 0.1rem;
  font-size: 0.48889rem;
}
</style>
<style>
@import "./common/global.css";
@import "./font/font.css";
/* * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  font-family:"zkFont";
} */
body >>> .van-toast {
  /* background-color: #DE9C62; */
  background-color: #8d3328;
  min-width: 5.66667rem;
  border-radius: 0.1rem;
  font-size: 0.48889rem;
}
</style>
